
export interface userLoginData {
    businessName: string;
    contactName: string;
    businessCr: string;
    contactNumber: string;
    contactEmail: string;
}
export const DEFAULT_DATA: userLoginData= {businessName: '', contactName: '', businessCr: '', contactNumber: '', contactEmail: ''}
